import { styled, css } from '@volkswagen-onehub/components-core';

export const HuchaWrapper = styled.div<{ $bonoPosventaExists: boolean }>`
	display: flex;
	flex-direction: column;
	gap: var(--size-dynamic0130);

	& div[data-testid='card-c1-container'] {
		flex: 1;
	}
	& div[data-testid='card-c2-container'] {
		flex: 1;
	}
	& div[data-testid='card-c3-container'] {
		flex: 1;
	}

	${({ $bonoPosventaExists }: { $bonoPosventaExists: boolean }) =>
		!$bonoPosventaExists &&
		css`
			@media (min-width: 1045px) {
				gap: var(--size-dynamic0200);
				flex-direction: row;
				justify-content: center;
				align-items: center;
			}
		`}
`;

export const HuchaCol = styled.div<{ $bonoPosventaExists: boolean }>`
	flex: 1;

	display: flex;
	flex-direction: column;
	align-items: unset;
	gap: var(--size-dynamic0130);

	${({ $bonoPosventaExists }: { $bonoPosventaExists: boolean }) =>
		$bonoPosventaExists
			? css`
					@media (min-width: 1260px) {
						gap: var(--size-dynamic0200);
						align-items: center;
						flex-direction: row;
					}
				`
			: css`
					@media (min-width: 710px) {
						gap: var(--size-dynamic0200);
						align-items: center;
						flex-direction: row;
					}
				`}
`;
